/************************************
MODULE:         Settings
WHAT IT DOES:   Configures some global classes before the rest of js is called
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory();
    }
    else { root.returnExports = factory(); } 
}(this, function () {

    function initSettings() {
        fixClasses();
    }

    function fixClasses() {
        if (!!('ontouchstart' in window || navigator.msMaxTouchPoints) && navigator.userAgent.match(/Windows Phone/i)) {
            var currentClass = document.documentElement.getAttribute('class');
            currentClass = currentClass ? currentClass : "";
            currentClass = currentClass.replace('no-touch', 'touch');
            currentClass += " windows-mobile";
            document.documentElement.setAttribute('class', currentClass);
        }
    }

    return {
        init: initSettings
    };
}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.settings.js
 ** module id = 57
 ** module chunks = 24
 **/